export interface FinalReportGridItemModel {
  reportId: number;
  fileCode: string;
  fileContentTypeId: number;
  company: string | null;
  generatedBy: string;
  date: Date;
  dateAdded: Date;
  canDownload: boolean;
  canDelete: boolean;

  isDownloading: boolean;
  isDeleting: boolean;

  onDownload: (item: FinalReportGridItemModel) => void;
  onDelete: (reportId: number, fileContentTypeId: number) => void;
}

export interface CompanyItem {
  id: number;
  name: string;
}

export enum ReportFileContentTypes {
  FinalReport = 1,
  FinalMonthlyInvoices = 2,
  AdvanceInvoice = 3,
}

export enum SelectGroupTypes {
  ForAllCompanies = 0,
  OnlyForThisCompany = 1,
}

export const toSelectedGroupString: { [key: number]: string } = {
  [SelectGroupTypes.ForAllCompanies]: 'for_all_companies',
  [SelectGroupTypes.OnlyForThisCompany]: 'only_for_this_company',
};
